if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /**
         * Init module
         * @param {jQuery<HTMLElement>} $container containerElement
         * @constructor
         */
        ZZ.UpdateAVGemak = function($container) {
            this.cacheDomQueries($container);
            this.assignListeners();
        };

        /**
         * Cache
         * @param {jQuery<HTMLElement>} $container containerElement
         */
        ZZ.UpdateAVGemak.prototype.cacheDomQueries = function($container) {
            this.$bvRadio = $container;
            this.$avCompareTableContainer = $(
                "#" +
                    $($container.attr("data-update-gemak-av-close")).attr(
                        "data-target"
                    )
            );

            this.$avSelect = $($container.attr("data-update-gemak-av-select"));
            this.$avSelectOptions = this.$avSelect.find("option");

            this.$avCarrousel = $($container.attr("data-update-gemak-av"));

            this.$avTable = $($container.attr("data-update-gemak-av-table"));
            this.$avTableHTML = this.$avTable.html();

            this.$avTableClose = $(
                $container.attr("data-update-gemak-av-close")
            );

            this.$currSelecteBvType = "";
        };

        /**
         * Attach event listeners
         *  When all modules have finished loading
         */
        ZZ.UpdateAVGemak.prototype.assignListeners = function() {
            ZZ.root.addEventListener(
                "data-finished-loading",
                function() {
                    // Bind event handlers
                    this.$bvRadio
                        .find("input, select")
                        .addBack()
                        .on("change", this.onChangeBV.bind(this));
                    this.$avSelect.on("change", this.onChangeAV.bind(this));

                    this.setServersideSelectedOption(this.$bvRadio);
                    this.setServersideSelectedOption(this.$avSelect);

                    this.$optionsAv = this.$avSelectOptions.clone();

                    this.$avTable.on(
                        "rebuild.compareTable",
                        this.reAssignModules.bind(this)
                    );
                    // Call handlers initially
                    this.onChangeBV();
                    this.onChangeAV();

                    this.initTargetGroupDiscount();
                }.bind(this)
            );
        };

        /**
         * BV Change event handler
         */
        ZZ.UpdateAVGemak.prototype.onChangeBV = function() {
            if (this.isNoneValue(this.$bvRadio)) {
                this.showAllAVs();
            } else if (this.isGemakBV()) {
                this.showGemakAVs();
            } else if (this.isRegularBV()) {
                this.showRegularAVs();
            }
            this.initTargetGroupDiscount();
        };

        ZZ.UpdateAVGemak.prototype.setServersideSelectedOption = function(
            $select
        ) {
            // als een van de options op selected is gezet serverside dan onthouden we die om die op selected te zetten bij pageload
            $select.find("option, input").each(function() {
                if (
                    this.hasAttribute("selected") ||
                    this.hasAttribute("checked")
                ) {
                    $select.attr(
                        "data-optionSelected",
                        this.getAttribute("value")
                    );
                }
            });
        };

        /**
         * AV Change event handler
         *  Closes the carrousel
         */
        ZZ.UpdateAVGemak.prototype.onChangeAV = function() {
            if (this.isNoneValue(this.$avSelect)) {
                if (
                    this.$avSelect.find(":selected").attr("data-value-none") ===
                    "close-carousel"
                ) {
                    if (!this.$avCompareTableContainer.hasClass("closed")) {
                        this.$avTableClose.click();
                    }
                }
            }

            this.initTargetGroupDiscount();
        };

        /**
         * Is a Gemak BV selected?
         * @returns {Boolean} boolean
         */
        ZZ.UpdateAVGemak.prototype.isGemakBV = function() {
            return this.$bvRadio
                .find(":checked, :selected")
                .is("[data-is-bv-gemak]");
        };

        /**
         * Is a Regular BV selected?
         * @returns {Boolean} boolean
         */
        ZZ.UpdateAVGemak.prototype.isRegularBV = function() {
            return this.$bvRadio
                .find(":checked, :selected")
                .is("[data-is-bv-regular]");
        };

        /**
         * Is a none-value selected?
         * @param {jQuery<HTMLElement>} $selectOrRadiosElement selectElement
         * @returns {Boolean} boolean
         */
        ZZ.UpdateAVGemak.prototype.isNoneValue = function(
            $selectOrRadiosElement
        ) {
            return $selectOrRadiosElement
                .find(":checked, :selected")
                .is("[data-value-none]");
        };

        /**
         * Select the first <option> in a <select> element
         * @param {jQuery<HTMLSelectElement>} $select selectElement
         */
        ZZ.UpdateAVGemak.prototype.selectFirstOption = function($select) {
            if (
                $($select).attr("data-optionSelected") === undefined ||
                this.isDataOptionSelectedValueNotPresent($select)
            ) {
                $select.val(
                    $select
                        .children("option")
                        .first()
                        .val()
                );
            } else {
                $($select).val($($select).attr("data-optionSelected"));
                var t = $($select).find(
                    'option[value="' +
                        $($select).attr("data-optionSelected") +
                        '"]'
                );
                t.attr("selected", true);
                $($select).removeAttr("data-optionSelected");
            }
        };

        /**
         * check if the data-optionSelected value is not present in the current select options
         * (which can be filtered by the Gemak filter functionality)
         * @returns {Boolean} boolean
         */
        ZZ.UpdateAVGemak.prototype.isDataOptionSelectedValueNotPresent = function(
            $select
        ) {
            return !$($select).is(
                'option[value="' + $($select).attr("data-optionSelected") + '"]'
            );
        };

        /**
         * Show all AV's, cancelling any possible filter
         */
        ZZ.UpdateAVGemak.prototype.showAllAVs = function() {
            var currentSelectedAvOptionValue = this.$avSelect
                .find("option:selected")
                .val();

            // Show all nodes in AV carrousel
            this.$avTable.html(this.$avTableHTML);
            this.$avTable.trigger("rebuild.compareTable");
            this.$avTable.length > 0 &&
                this.$avTable
                    .get(0)
                    .dispatchEvent(new CustomEvent("rebuild.compareTable"));

            if (
                this.$bvRadio
                    .find(":checked, :selected")
                    .attr("data-is-bv-gemak") !== undefined
            ) {
                this.showGemakAVs();
            } else if (
                this.$bvRadio
                    .find(":checked, :selected")
                    .attr("data-is-bv-regular") !== undefined
            ) {
                this.showRegularAVs();
            } else {
                this.$currSelecteBvType = "isNoneBV";
                this.showRegularAVs();
                this.$avSelect.val(currentSelectedAvOptionValue);
            }

            // Re-initialize CompareCarousel module
            var module = ZZ.initializedByElement(
                this.$avCarrousel,
                ZZ.CompareCarousel
            );
            module && module.instance && module.instance.init();
        };

        /**
         *  omdat we html uit de DOM halen en weer terug zetten moeten we de modules in de html opnieuw initieren
         */
        ZZ.UpdateAVGemak.prototype.reAssignModules = function() {
            var t = $('tr.show-more [data-interaction="Toggle"]');
            t.each(function() {
                new ZZ.Toggle($(this));
            });
        };

        /**
         * Show only Gemak AV's
         */
        ZZ.UpdateAVGemak.prototype.showGemakAVs = function() {
            // var avLastOptionValue = this.$avSelect.find('option:last-child').val();
            // var currentSelectedAvOptionValue = this.$avSelect.find('option:selected').val();
            // var isCurrentSelectedBvTypeNotGemakBvValue = this.isNoneBVandTargetAvPresentInTargetBV();

            // Show & hide options in AV selectbox
            if (this.$currSelecteBvType !== "isGemakBV") {
                this.$avSelect.find("option").remove();
                this.$avSelect.append(this.$optionsAv);
                this.$avSelect.find("[data-is-av-regular]").remove();
            }

            // Show elements outside carrousel
            $("[data-hide-with-product]").each(function() {
                $(this).css("display", "block");
            });

            // Hide elements outside carrousel
            $("[data-hide-with-product='ZVW-ZWGMK']").each(function() {
                $(this).css("display", "none");
            });

            // Show & hide nodes in AV carrousel
            this.$avTable.html(this.$avTableHTML);
            this.$avTable.find("[data-is-av-regular]").remove();
            this.$avTable.trigger("rebuild.compareTable");
            this.$avTable.length > 0 &&
                this.$avTable
                    .get(0)
                    .dispatchEvent(new CustomEvent("rebuild.compareTable"));

            var dataShareDentistTrigger = $("[data-share-dentist-trigger]");
            dataShareDentistTrigger.trigger("toggle.dentalSharing");
            dataShareDentistTrigger > 0 &&
                dataShareDentistTrigger
                    .get(0)
                    .dispatchEvent(new CustomEvent("rebuild.compareTable"));

            this.$currSelecteBvType = "isGemakBV";

            // Re-initialize CompareCarousel module
            var module = ZZ.initializedByElement(
                this.$avCarrousel,
                ZZ.CompareCarousel
            );
            module && module.instance && module.instance.init();

            this.$bvRadio.attr(
                "data-previous-bv-type",
                this.currentSelectedPolisType(this.$bvRadio)
            );
        };

        /**
         * Hide Gemak AV's
         */
        ZZ.UpdateAVGemak.prototype.showRegularAVs = function() {
            var avLastOptionValue = this.$avSelect
                .find("option:last-child")
                .val();
            var currentSelectedAvOptionValue = this.$avSelect
                .find("option:selected")
                .val();
            var isCurrentSelectedBvTypeNotRegularBvValue = this.isNoneBVandTargetAvPresentInTargetBV();

            // Show & hide options in AV selectbox
            if (this.$currSelecteBvType !== "isRegularBV") {
                this.$avSelect.find("option").remove();
                this.$avSelect.append(this.$optionsAv);
                this.$avSelect.find("[data-is-av-gemak]").remove();
            }

            // Show elements outside AV carrousel
            $("[data-hide-with-product]").each(function() {
                $(this).css("display", "block");
            });

            // Show & hide nodes in AV carrousel
            this.$avTable.html(this.$avTableHTML);
            this.$avTable.find("[data-is-av-gemak]").remove();
            this.$avTable.trigger("rebuild.compareTable");
            this.$avTable.length > 0 &&
                this.$avTable
                    .get(0)
                    .dispatchEvent(new CustomEvent("rebuild.compareTable"));

            // Select default
            if (isCurrentSelectedBvTypeNotRegularBvValue) {
                this.$avSelect.val(currentSelectedAvOptionValue);
            } else if (
                this.isSelectedAvOptionNotNoneAndSelectedBvNotPreviousBvType(
                    avLastOptionValue,
                    currentSelectedAvOptionValue
                )
            ) {
                this.selectFirstOption(this.$avSelect);
            }

            var dataShareDentistTrigger = $("[data-share-dentist-trigger]");
            dataShareDentistTrigger.trigger("toggle.dentalSharing");
            dataShareDentistTrigger.length > 0 &&
                dataShareDentistTrigger
                    .get(0)
                    .dispatchEvent(new CustomEvent("rebuild.compareTable"));

            this.$currSelecteBvType = "isRegularBV";

            // Re-initialize CompareCarousel module
            var module = ZZ.initializedByElement(
                this.$avCarrousel,
                ZZ.CompareCarousel
            );
            module && module.instance && module.instance.init();

            this.triggerTargetGroupDiscount();

            this.$bvRadio.attr(
                "data-previous-bv-type",
                this.currentSelectedPolisType(this.$bvRadio)
            );
        };

        ZZ.UpdateAVGemak.prototype.isSelectedAvOptionNotNoneAndSelectedBvNotPreviousBvType = function(
            avLastOptionValue,
            currentSelectedAvOptionValue
        ) {
            return (
                avLastOptionValue !== currentSelectedAvOptionValue &&
                this.$bvRadio.attr("data-previous-bv-type") !==
                    this.currentSelectedPolisType(this.$bvRadio)
            );
        };

        ZZ.UpdateAVGemak.prototype.isNoneBVandTargetAvPresentInTargetBV = function() {
            var isCurrentBvTypeNoneAndSameTargetPolisType = false;

            var currentBvPolisType = this.currentSelectedPolisType(
                this.$bvRadio
            );
            var currentAvPolisType = this.currentSelectedPolisType(
                this.$avSelect
            );

            if (currentBvPolisType === currentAvPolisType) {
                isCurrentBvTypeNoneAndSameTargetPolisType = true;
            } else {
                isCurrentBvTypeNoneAndSameTargetPolisType = false;
            }

            return isCurrentBvTypeNoneAndSameTargetPolisType;
        };

        ZZ.UpdateAVGemak.prototype.currentSelectedPolisType = function(
            selectBvOrAv
        ) {
            var currentBvOrAvPolisType = "";
            var currentSelectedBvOrAvOption = selectBvOrAv.find(
                ":selected, :checked"
            );
            if (
                currentSelectedBvOrAvOption.is(
                    "[data-is-bv-gemak],[data-is-av-gemak]"
                )
            ) {
                currentBvOrAvPolisType = "gemak";
            } else if (
                currentSelectedBvOrAvOption.is(
                    "[data-is-bv-regular],[data-is-av-regular]"
                )
            ) {
                currentBvOrAvPolisType = "regular";
            }

            return currentBvOrAvPolisType;
        };

        /**
         * Trigger TargetGroupDiscount to redraw on the AV Carrousel after UpdateAvGemak resets the html
         * when selecting a Regular BV from the dropdown
         */
        ZZ.UpdateAVGemak.prototype.triggerTargetGroupDiscount = function() {
            var $targetGroupDiscountCheckbox = $(
                "[data-target-group-discount-checkbox]"
            );
            $targetGroupDiscountCheckbox.trigger("change.TargetGroupDiscount");
        };

        ZZ.UpdateAVGemak.prototype.initTargetGroupDiscount = function() {
            var $targetGroupDiscountCheckbox = $(
                "[data-target-group-discount-checkbox]"
            );
            $targetGroupDiscountCheckbox.trigger("init.TargetGroupDiscount");
        };
    })(jQuery);
}
